import { render, staticRenderFns } from "./responseRight.vue?vue&type=template&id=01a1e66f&scoped=true"
import script from "./responseRight.vue?vue&type=script&lang=js"
export * from "./responseRight.vue?vue&type=script&lang=js"
import style0 from "./responseRight.vue?vue&type=style&index=0&id=01a1e66f&prod&scoped=true&lang=css"
import style1 from "./responseRight.vue?vue&type=style&index=1&id=01a1e66f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a1e66f",
  null
  
)

export default component.exports